import {
    renderAccount,
    renderJra,
} from 'ff/common/components/FFMenuV2/MenuItems';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';
import renderDivider from 'ff/common/components/FFMenuV2/MenuItems/Divider';

export default function RenderJraMenu() {
    return [
        renderJra,
        renderDivider,
        renderAccount,
        fillSpace.bind(null, { flex: '1' }),
    ];
}
